import { render, staticRenderFns } from "./monitoring_configuration.vue?vue&type=template&id=56f842f5&scoped=true&"
import script from "./monitoring_configuration.vue?vue&type=script&lang=js&"
export * from "./monitoring_configuration.vue?vue&type=script&lang=js&"
import style0 from "./monitoring_configuration.vue?vue&type=style&index=0&id=56f842f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f842f5",
  null
  
)

export default component.exports